export default __webpack_public_path__ + "static/media/callMain.e472a2bf.svg";